export class RfxSyncStatusError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RfxSyncStatusError';
  }
}
